<div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">
            <button mat-button (click)="archiveCategory()">Archive Category</button>
        </div>
        <div class="middle">

        </div>
        <div class="right">
            <button mat-button mat-dialog-close>Close</button>
        </div>
    </div>

    <div class="navigation mobile">
        <div class="left">
            <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
        </div>
        <div class="middle">

        </div>
        <div class="right">
        </div>
    </div>
</div>


<div class="container" mat-dialog-content>
    <div class="left">
        <!-- <mat-form-field appearance="fill" style="width: 100%;">
            <mat-select
            [value]="type"
            (selectionChange)="changeTypes($event.value)" 
            placeholder="">
                <mat-option *ngFor="let type of types" [value]="type.name">{{type.nicename}}</mat-option>
            </mat-select>
        </mat-form-field> -->

        <button mat-raised-button (click)="tab='features'">Item Data</button>
        <button mat-raised-button (click)="tab='guide'">Guide</button>

        <h3>Sale Channels</h3>
       
        <button *ngIf="hasTemplate('facebook')" mat-raised-button (click)="tab='facebook'">Facebook</button>
        <button *ngIf="!hasTemplate('facebook')" mat-stroked-button (click)="addFacebook()">Add Facebook</button>

        <button *ngIf="hasTemplate('ebay')" mat-raised-button (click)="tab='ebay'">Ebay</button>
        <button *ngIf="!hasTemplate('ebay')" mat-stroked-button (click)="addEbay()">Add Ebay</button>

        <button *ngIf="hasTemplate('webflow')" mat-raised-button (click)="tab='webflow'">Webflow</button>
        <button *ngIf="!hasTemplate('webflow')" mat-stroked-button (click)="addWebflow()">Add Webflow</button>


        <mat-card class="toolbar">
            <mat-card-header>
                <mat-card-title>Template Variables</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="template != undefined">
                    <div class="variable" (mouseup)="copyToClipboard('#{{number}}')">#{{"{{number}}"}}</div>
                    <div class="variable" (mouseup)="copyToClipboard(variable)" *ngFor="let variable of getItemVariables()">{{variable}}</div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="toolbar">
            <mat-card-header>
                <mat-card-title>Temp Ebay Tool</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <button (click)="lookupSpecifics(lookupCategory.value)" mat-raised-button color="">Lookup Specifics</button>
                <mat-form-field appearance="outline">
                    <mat-label>Category</mat-label>
                    <input matInput #lookupCategory maxlength="1000">
                  </mat-form-field>

                  <h2 *ngIf="categoryLookupDate.required.length > 0">Required</h2>
                  <ul>
                    <li *ngFor="let item of categoryLookupDate.required">{{item.name}}</li>
                  </ul>

                  <h2 *ngIf="categoryLookupDate.recommended.length > 0">Recommended</h2>
                  <ul>
                    <li *ngFor="let item of categoryLookupDate.recommended">{{item.name}}</li>
                  </ul>

                  <h2 *ngIf="categoryLookupDate.optional.length > 0">Optional</h2>
                  <ul>
                    <li *ngFor="let item of categoryLookupDate.optional">{{item.name}}</li>
                  </ul>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="right">

        <div *ngIf="isLoaded">


            <ng-container *ngIf="tab == 'features'">
                <mat-card *ngVar="getTemplate('features') as component">
                    <div class="component-header">
                        <h2>Item Data</h2>
                        <div class="tools">
                            <button mat-icon-button [matMenuTriggerFor]="menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="copyComponent(i)">
                                <mat-icon>content_copy</mat-icon>
                                <span>Copy</span>
                                </button>
                                <button mat-menu-item (click)="pasteComponent(i)">
                                <mat-icon>content_copy</mat-icon>
                                <span>Paste</span>
                                </button>
                                <button mat-menu-item (dblclick)="deleteComponent(i)">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                                </button>
                            </mat-menu>
                        </div>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Title</mat-label>
                        <input matInput [(ngModel)]="component.data.title" (blur)="save()">
                    </mat-form-field>

                    <div *ngFor="let feature of component.data.required; let x = index">
                        <div class="feature">
                            <div class="custom-label">
                                <input (blur)="saveFeatureLabel(x, $event.target.value)" placeholder="Label" [value]="feature.label" matInput>
                            </div>
                            <div class="text">
                                <mat-select (selectionChange)="save()" [(ngModel)]="feature.type">
                                    <mat-option value="text">Text</mat-option>
                                    <mat-option value="select">Select</mat-option>
                                </mat-select>
                            </div>
                            <div class="action">
                                <span (click)="featureUp(x)"><mat-icon>arrow_upwards</mat-icon></span>
                                <span (click)="featureDown(x)"><mat-icon>arrow_downwards</mat-icon></span>
                                <span (click)="deleteFeature(x)"><mat-icon>delete</mat-icon></span>
                            </div>
                        </div>

                        <ng-container *ngIf="feature.type == 'select'">
                            <div *ngFor="let option of feature.options; let z = index" class="feature select-options">
                                <div class="label">
                                    Option {{z+1}}
                                </div>
                                <div class="text">
                                    <input (blur)="saveOption(x, z, $event.target.value)" placeholder="Text" [value]="option" matInput aria-label="field-text">
                                </div>
                                <div class="action">
                                    <span (click)="featureOptionDown(x, z)"><mat-icon>arrow_upwards</mat-icon></span>
                                    <span (click)="featureOptionUp(x, z)"><mat-icon>arrow_downwards</mat-icon></span>
                                    <span (click)="deleteOptionFeature(x, z)"><mat-icon>delete</mat-icon></span>
                                </div>
                            </div>
                            <div class="feature select-options add-option">
                                <button (click)="addOptionFeature(x)" mat-button>Add Option</button>
                            </div>
                        </ng-container>
                    </div>

                    <div class="feature-actions">
                        <button (click)="addFeature()" mat-raised-button>Add Feature</button>
                    </div>
                    
                </mat-card>
            </ng-container>
            
            <ng-container *ngIf="tab == 'guide'">
                <mat-card>
                    <mat-form-field appearance="outline">
                        <mat-label>Example Item #</mat-label>
                        <input matInput [(ngModel)]="category.guide.exampleItem" (blur)="save()">
                    </mat-form-field>
                </mat-card>
            </ng-container>

            <ng-container *ngIf="tab == 'ebay'">
                <ng-container *ngIf="hasTemplate('ebay')">
                    <mat-card *ngVar="getTemplate('ebay') as component">
                        <div class="component-header">
                            <h2>Ebay</h2>

                            <div class="tools">
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="deleteTemplate('ebay')">
                                    <mat-icon>delete</mat-icon>
                                    <span>Delete</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </div>

                        <mat-form-field appearance="outline">
                            <mat-label>Ebay Title</mat-label>
                            <input matInput [(ngModel)]="component.data.title" (blur)="save()">
                        </mat-form-field>
                    
                        <ap-money [(amount)]="component.data.price" outline="true" (amountChange)="save()"></ap-money>
                    
                        <mat-form-field appearance="outline">
                            <mat-label>Condition</mat-label>
                            <mat-select 
                            [(value)]="component.data.condition"
                            (selectionChange)="save()">
                                <mat-option value="1000">Brand New</mat-option>
                                <mat-option value="1500">Opened - never used</mat-option>
                                <mat-option value="2500">Seller Refurbished</mat-option>
                                <mat-option value="3000">Used</mat-option>
                                <mat-option value="7000">For parts or not working</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Category</mat-label>
                            <input matInput [(ngModel)]="component.data.category" (blur)="save()">
                        </mat-form-field>

                        <h3>Item Specifics</h3>
                        <div class="feature" *ngFor="let aspect of component.data.aspects; let x = index">
                            <div class="custom-label">
                                <input (blur)="saveEbayAspectLabel(x, $event.target.value)" placeholder="Label" [value]="aspect.label" matInput>
                            </div>
                            <div class="text">
                                <input (blur)="saveEbayAspectValue(x, $event.target.value)" placeholder="Text" [value]="aspect.value" matInput aria-label="field-text">
                            </div>
                            <div class="action">
                                <button (click)="deleteEbayAspect(x)" mat-button><mat-icon>delete</mat-icon></button>
                            </div>
                        </div>

                        <div class="feature-actions">
                            <button (click)="addEbayAspect(i)" mat-raised-button>Add Item Specific</button>
                        </div>

                        <h3>Description</h3>
                        <ckeditor [editor]="Editor" (blur)="descriptionOnBlur($event)" [data]="component.data.description"></ckeditor>

                    </mat-card>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="tab == 'facebook'">

                <ng-container *ngIf="hasTemplate('facebook')">
                    <mat-card *ngVar="getTemplate('facebook') as component">
                        <div class="component-header">
                            <h2>Facebook</h2>

                            <div class="tools">
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="deleteTemplate('facebook')">
                                    <mat-icon>delete</mat-icon>
                                    <span>Delete</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </div>

                        <mat-form-field appearance="outline">
                            <mat-label>Facebook Title</mat-label>
                                <input matInput [(ngModel)]="component.data.title" (blur)="save()">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Facebook Content</mat-label>
                                <textarea matInput
                                            [(ngModel)]="component.data.description"
                                            cdkTextareaAutosize
                                            #autosize="cdkTextareaAutosize"
                                            cdkAutosizeMinRows="10"
                                            cdkAutosizeMaxRows="50"
                                            (blur)="save()"></textarea>
                                </mat-form-field>
                    </mat-card>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="tab == 'webflow'">
                <ng-container *ngIf="hasTemplate('webflow')">
                    <mat-card *ngVar="getTemplate('webflow') as component">
                        <div class="component-header">
                            <h2>Webflow</h2>

                            <div class="tools">
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="deleteTemplate('webflow')">
                                    <mat-icon>delete</mat-icon>
                                    <span>Delete</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </div>

                        <mat-form-field appearance="outline">
                            <mat-label>Webflow Title</mat-label>
                            <input matInput [(ngModel)]="component.data.title" (blur)="save()">
                        </mat-form-field>
                    </mat-card>
                </ng-container>
            </ng-container>

        </div>
    </div>

</div>


